<template>
    <v-data-table :headers="headers" :items="vereine" :items-per-page="itemsPerPage"
                  :search="search" @current-items="setFiltered"
                  :footer-props="{'items-per-page-options': [5, 10, 15, -1]}">
    </v-data-table>
</template>

<script>
export default {
    name: "vereins-liste",
    props: ['vereine', 'search'],
    computed: {
        itemsPerPage(){ return this.search ? -1 : 15}
    },
    data: () => ({
        headers: [
            {text: 'LV', value: 'lvId'},
            {text: 'nr', value: 'nr'},
            {text: 'Name', value: 'name'},
            {text: 'Status', value: 'status'},
            {text: 'ZVR-Nr', value: 'zvrNr'},
            {text: 'Sitz-Name', value: 'vereinsSitz.name'},
            {text: 'Straße', value: 'vereinsSitz.strasse'},
            {text: 'PLZ', value: 'vereinsSitz.plz'},
            {text: 'Ort', value: 'vereinsSitz.ort'},
            {text: 'Telefon', value: 'vereinsSitz.telefon'},
            {text: 'E-Mail', value: 'vereinsSitz.email'},
            {text: 'Inhaber', value: 'bankVerbindung.inhaber'},
            {text: 'Institut', value: 'bankVerbindung.institut'},
            {text: 'IBAN', value: 'bankVerbindung.iban'},
            {text: 'Post-Name', value: 'postZustellAdresse.name'},
            {text: 'Post-Straße', value: 'postZustellAdresse.strasse'},
            {text: 'Post-PLZ', value: 'postZustellAdresse.plz'},
            {text: 'Post-Ort', value: 'postZustellAdresse.ort'},
        ]
    }),
    methods: {
        setFiltered(e){
            if ( this.search ) {
                this.$emit('filtered', e);
            } else {
                this.$emit('filtered', this.vereine)
            }
        }
    },
}
</script>

<style scoped>

</style>